import { MessageBar, MessageBarType } from "@fluentui/react";
import { observer } from "mobx-react";
import React from "react";
import { store } from "../../store";

@observer
export default class ErrorBars extends React.Component {
    public render(): JSX.Element {
        if (!store.serviceErrors.nextError) {
            return <></>;
        }
        const { title, description, id, additionalInformation, html } =
            store.serviceErrors.nextError;
        return (
            <MessageBar
                messageBarType={MessageBarType.error}
                onDismiss={() => store.serviceErrors.dismissError(id)}
            >
                <h3>
                    <>{store.i18n.t(title, additionalInformation ?? {})}</>{" "}
                    <>
                        {store.serviceErrors.count > 1 ? (
                            store.i18n.t("component.errorBar.count", {
                                count: store.serviceErrors.count - 1,
                            })
                        ) : (
                            <></>
                        )}
                    </>
                </h3>
                <p>{store.i18n.t(description, additionalInformation)}</p>
                {html}
            </MessageBar>
        );
    }
}
